export const LaCon = 'https://api-demo.doevidas.com.br/'//'http://192.168.15.10:8000/';//'http://api.doevidas.com.br/';//'http://127.0.0.1:8000/'//
export const SelfLink = 'https://demo.doevidas.com.br/';
export const Passport = '0m8RoL8Futa2EIrJHiUnN1rVPrXmE1F5X14Y9D4S';